import { Component } from "@angular/core";
import { EceButtonComponent } from "./ece.button.component";

@Component({
    selector: "ece-btn-delete",
    templateUrl: "./ece.button.component.html",
    standalone: false
})
export class DeleteButtonComponent extends EceButtonComponent {
  icon = "close";
}
